import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import * as catalogService from '@services/catalogService'
import * as S from './CatalogGoodItem.styled'
import PriceBlock from './PriceBlock/PriceBlock'
import ModalWindow from '../shared/ModalWindow/ModalWindow'
import MarkerContainer from '../MarkerContainer/MarkerContainer'
import { useOpenStockForGoods } from 'src/features/shipment-selector/hooks'
import { useIsDelivery } from 'src/pages/order/basket/hooks'
const checkAvailableGood = (isDelivery, good) => {
    const priceNormal = isDelivery ? good.deliveryPrice?.normal : good.stockPrice?.normal
    if (!isDelivery && good.isAvailable && good.isAvailableOnStock && priceNormal) {
        return true
    }
    // noinspection RedundantIfStatementJS
    if (
        isDelivery &&
        good.isAvailable &&
        (good.isAvailableForDelivery || good.isAvailableDeliveryByErecipe) &&
        priceNormal
    ) {
        return true
    }
    return false
}

const getGoodsUrl = (goodGroups, groupId, url, webId) => {
    try {
        if (groupId) {
            const group = goodGroups.find((x) => x.clsGroupID === groupId)
            if (group) {
                return `/catalog/${group.groupUrl}/${url}-${webId}`
            }
        }

        const groupDefault = goodGroups.find((x) => x.isDefault)
        return `/catalog/${groupDefault.groupUrl}/${url}-${webId}`
    } catch {
        console.error('webId not found groups: ', webId)
        return ''
    }
}

// eslint-disable-next-line react/prop-types
const CatalogGoodItem = ({ children, shipment, isShowedWarningBorder, isSelectedShipment }) => {
    const isDelivery = useIsDelivery()
    const [deliveryReasonState, setDeliveryReasonState] = useState({
        isShowedModal: false,
        reasons: []
    })
    const openStockForGoods = useOpenStockForGoods()

    const openDeliveryReasons = (reasons) => {
        setDeliveryReasonState({
            ...deliveryReasonState,
            isShowedModal: true,
            reasons
        })
    }
    const closeDeliveryReasons = () => {
        setDeliveryReasonState({
            ...deliveryReasonState,
            isShowedModal: false,
            reasons: []
        })
    }

    const mnn = children.webData.mnnRusTitle

    const isMNN = mnn && mnn.toLowerCase().trim() !== 'не установлено' && mnn.toLowerCase().trim() !== '-'

    const clickOpenAnotherStockHandler = () => {
        openStockForGoods([children.webData.goodId])
    }

    const goodUrl = getGoodsUrl(
        children.webData.goodGroups,
        children.groupId,
        children.webData.url,
        children.webData.webId
    )

    const available = checkAvailableGood(isDelivery, children)
    return (
        <S.Container
            data-good-is-available-delivery-by-erecipe={children.isAvailableDeliveryByErecipe}
            data-good-id={children.webData.goodId}
            isWarningBorder={isShowedWarningBorder && !available}>
            <Link href={goodUrl} passHref legacyBehavior>
                <S.ImageContainer>
                    <S.GoodImage
                        src={catalogService.getUslImage(children.webData.hasImage, children.webData.goodId)}
                        onError={(e) => {
                            e.target.onerror = null
                            e.target.src = catalogService.errorImage
                        }}
                    />
                </S.ImageContainer>
            </Link>
            <S.InfoContainer>
                <S.FullInfo>
                    <Link href={goodUrl} passHref legacyBehavior>
                        <S.FullTitle>{`${children.webData.drugTitle} ${children.webData.outFormTitle}`}</S.FullTitle>
                    </Link>
                    <S.TextInfoContainer>
                        <S.TextInfo>
                            <S.TextInfoDescription>{children.webData.makerTitle}</S.TextInfoDescription>
                        </S.TextInfo>
                        {isMNN && (
                            <S.TextInfo>
                                <S.TextInfoName>Действующее вещество: </S.TextInfoName>
                                <S.TextInfoDescription>{children.webData.mnnRusTitle}</S.TextInfoDescription>
                            </S.TextInfo>
                        )}
                    </S.TextInfoContainer>
                    <S.MarkerBlock>
                        <MarkerContainer
                            stockPrice={children.stockPrice}
                            deliveryPrice={children.deliveryPrice}
                            isCold={children.isCold}
                            isOriginalGood={children.isOriginalGood}
                            isStrictlyByPrescription={children.isStrictlyByPrescription}
                            isAvailableDeliveryByErecipe={children.isAvailableDeliveryByErecipe}
                        />
                    </S.MarkerBlock>
                </S.FullInfo>
            </S.InfoContainer>
            <S.PriceContainer>
                <S.PriceDataContainer>
                    <PriceBlock
                        isSelectedShipment={isSelectedShipment}
                        isSelectedStock={!!(shipment?.stockId && shipment.stockId > 0)}
                        bookedCount={children.bookedCount}
                        isChanged={children.isChanged}
                        availableStocksCount={children.availableStocksCount}
                        clickOpenAnotherStockHandler={clickOpenAnotherStockHandler}
                        stockPrice={children.stockPrice}
                        deliveryPrice={children.deliveryPrice}
                        minPrice={children.minPrice}
                        deliveryStatus={children.deliveryStatus}
                        isAvailable={children.isAvailable}
                        isAvailableOnStock={children.isAvailableOnStock}
                        openDeliveryReasons={openDeliveryReasons}
                        closeDeliveryReasons={closeDeliveryReasons}
                        goodId={children.webData.goodId}
                        goodName={`${children.webData.drugTitle} ${children.webData.outFormTitle}`}>
                        {children}
                    </PriceBlock>
                    {/*  <FixPriceBlock
                      basketItemCount={children.basketItemCount}
                      good={children}
                      price={children.fixPrice}
                      count={children.count}
                      goodId={children.webData.goodId}
                    />*/}
                </S.PriceDataContainer>
            </S.PriceContainer>
            {deliveryReasonState.isShowedModal && (
                <ModalWindow
                    title="Внимание"
                    isButtonFooter={false}
                    isFooterOnlyOneButton
                    cancel={{
                        text: 'Отмена',
                        clickHandler: closeDeliveryReasons
                    }}>
                    <S.ReasonContainer>
                        {deliveryReasonState.reasons.map((reason) => (
                            <S.ReasonTextItem key={reason.id} dangerouslySetInnerHTML={{ __html: reason.text }} />
                        ))}
                    </S.ReasonContainer>
                </ModalWindow>
            )}
        </S.Container>
    )
}

CatalogGoodItem.propTypes = {
    shipment: PropTypes.object.isRequired,
    groupId: PropTypes.number
}
CatalogGoodItem.defaultProps = {
    isShowedWarningBorder: false,
    isSelectedShipment: null,
    isHidden: false
}

export default CatalogGoodItem
